import { render } from "./EditItem2.vue?vue&type=template&id=b0a035d6&scoped=true"
import script from "./EditItem2.vue?vue&type=script&lang=js"
export * from "./EditItem2.vue?vue&type=script&lang=js"

import "./EditItem2.vue?vue&type=style&index=0&id=b0a035d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a035d6"],['__file',"src/components/EditItem2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0a035d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0a035d6', __exports__)) {
    api.reload('b0a035d6', __exports__)
  }
  
  module.hot.accept("./EditItem2.vue?vue&type=template&id=b0a035d6&scoped=true", () => {
    api.rerender('b0a035d6', render)
  })

}


export default __exports__